// https://vitejs.dev/config/#build-polyfillmodulepreload
import 'vite/modulepreload-polyfill'

import './assets/scss/reset.scss'
import './assets/scss/fonts.scss'
import './assets/scss/cssVars.scss'
import './assets/scss/default.scss'
import './assets/scss/defaultText.scss'
import './assets/scss/print.scss'

if (import.meta.hot) {
  import.meta.hot.accept()
}

import.meta.glob('./modules/**/*.scss', { eager: true })
import.meta.glob('./modules/**/*.js', { eager: true })

import sprite from 'virtual:icon-sprite'
document.body.insertAdjacentHTML('beforeend', sprite)
